import { useState } from "react"
import styled from "styled-components";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";
import Overlay from "../../../Componentes/Overlay";

import useApi from "../../../hooks/useApi";
const Titulo = styled.h3`
    margin: 5px auto;
    text-align: center;
    color: #7d0000;
    font-size: 15px;
`
const ContainerBotoes = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
    margin-top: 20px;
`
const BotaoConfirmar = styled.button`
    width: calc( 50% - 5px );
    height: 35px;
    background-color: #DC2625;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    font-weight: bold;
    transition: .3s;
    &:hover {
        background-color: #B91C1C;
        scale: 1.05;
    }
`
const BotaoCancelar = styled.button`
    width: calc( 50% - 5px );
    height: 35px;
    background-color: #fff;
    color: black;
    border: 2px solid #ccc;
    cursor: pointer;
    border-radius: 5px;
    font-weight: bold;
    transition: .3s;
    &:hover {
        background-color: #f0f0f0;
        border-color: #aaa;
        scale: 1.05;
    }
`

const ConfirmText = styled.p`
    color: #333;
    text-align: justify;
`

const ModalDeleteTreinamento = ({ item = null, onSuccess }) => {
    const api = useApi();


    const [ loading, setLoading ] = useState( false );
    const { closeModal } = useModal();

    const handleDelete = async () => {

        setLoading( true );
        try{

            const formData = new FormData();
            formData.append("id", item.identifier);

            const url = "/Painel/API/Treinamentos/DeleteCatalogoTreinamento/";
            const { data } = await api.post( url, formData, { withCredentials: true } );

            console.log( data );
            if( onSuccess ) onSuccess();

        }catch( error ){

            console.error( error );
            alert("Erro ao deletar treinamento. Tente novamente mais tarde.");

        }finally{

            setLoading( false );

        }

    }

    return(
        <Overlay state={ true } >
            <Modal size="md" close={ true } >
                <Titulo>DELETAR TREINAMENTO</Titulo>
                <ConfirmText>Você tem certeza que deseja deletar o treinamento <strong>{ item.treinamento }</strong>? Esta ação não pode ser desfeita.</ConfirmText>
                <ContainerBotoes>
                    <BotaoConfirmar onClick={ handleDelete } disabled={ loading }>
                        { loading ? "DELETANDO..." : "DELETAR" }
                    </BotaoConfirmar>
                    <BotaoCancelar onClick={ () => closeModal() }>CANCELAR</BotaoCancelar>
                </ContainerBotoes>
            </Modal>
        </Overlay>
    );

}

export default ModalDeleteTreinamento;